module.exports = __webpack_public_path__ + "img/quest_icon_0039_star.c207b3d2.png";